import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface displayErrorProps {
    errorMessage: string
    setShowOverlay?: Function
    scrollTop?: boolean
}

const displayError = (props: displayErrorProps) => {
    
    Store.dispatch(setMessage(props.errorMessage, 'error', 'instant', props.scrollTop === undefined ? true : props.scrollTop))
    if(props.setShowOverlay !== undefined){
        props.setShowOverlay(false)
    }
    if([true, undefined].includes(props.scrollTop)){
        window.scrollTo(0, 0)
    }

    return true
}

export default displayError